import { useDraftProvider } from '../../../Draft'
import { useEmailDraftId } from '../useEmailDraftId'

export function useEmailDraftProvider(prefix) {
  const draftId = useEmailDraftId(prefix)

  return useDraftProvider({ draftId })
}
